/**
 * Pattern Admin Page
 * ==================
 * 
 * Admin page for managing classification patterns.
 * Accessible to admin and owner roles only.
 */

import React from 'react';
import AppLayout from '../components/AppLayout';
import PatternAdminDashboard from '../components/admin/PatternAdminDashboard';
import { usePermissions } from '../contexts/PermissionsContext';
import { AlertTriangle } from 'lucide-react';

export default function PatternAdminPage() {
  const { role } = usePermissions();
  
  // Check if user has admin access
  const hasAccess = role === 'admin' || role === 'owner';
  
  if (!hasAccess) {
    return (
      <AppLayout>
        <div className="flex items-center justify-center h-full">
          <div className="text-center">
            <AlertTriangle size={48} className="mx-auto mb-4" style={{ color: 'var(--color-brand)' }} />
            <h1 className="cs-display mb-2">Access Denied</h1>
            <p className="cs-body">
              This page is only accessible to administrators and owners.
            </p>
          </div>
        </div>
      </AppLayout>
    );
  }

  return (
    <AppLayout>
      <PatternAdminDashboard />
    </AppLayout>
  );
}
